import React from "react";
import { MdSms, MdLocationOn, MdSchedule } from "react-icons/md";
import { AiFillPhone } from "react-icons/ai";

export default function Location() {
  return (
    <div className="font-nunito mx-auto my-12 max-w-5xl px-6">
      <div className="overflow-hidden rounded-3xl bg-white shadow-2xl">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#457B9D] to-[#5a8fb0] px-8 py-8 text-center text-white">
          <MdLocationOn className="mx-auto mb-4 text-5xl" />
          <h2 className="mb-2 text-3xl font-bold md:text-4xl">Visit Us</h2>
          <p className="text-lg opacity-90">We're here to help and support you</p>
        </div>

        {/* Content */}
        <div className="p-8">
          {/* Quick Actions */}
          <div className="mb-8 grid gap-4 md:grid-cols-2">
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=4415+Jefferson+Ave%2C+Texarkana%2C+AR+71854"
              target="_blank"
              rel="noreferrer"
              className="group flex items-center justify-center gap-3 rounded-xl bg-[#457B9D] px-6 py-4 text-lg font-semibold text-white shadow-lg transition-all duration-300 hover:bg-[#365f7a] hover:shadow-xl"
            >
              <MdLocationOn className="text-2xl" />
              Get Directions
            </a>
            <a
              href="/contact"
              className="group flex items-center justify-center gap-3 rounded-xl border-2 border-[#457B9D] bg-white px-6 py-4 text-lg font-semibold text-[#457B9D] shadow-lg transition-all duration-300 hover:bg-[#457B9D] hover:text-white hover:shadow-xl"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              Send a Message
            </a>
          </div>

          {/* Location Info */}
          <div className="mb-8 rounded-2xl bg-blue-50 p-6">
            <div className="mb-4 flex items-start gap-4">
              <div className="mt-1 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-[#457B9D] text-white">
                <MdLocationOn className="text-xl" />
              </div>
              <div>
                <h3 className="mb-2 text-xl font-bold text-gray-800">
                  Pathway Resource Center
                </h3>
                <p className="text-lg text-gray-700">
                  4415 Jefferson Ave, Texarkana, AR 71854
                </p>
              </div>
            </div>
          </div>

          {/* Contact Methods */}
          <div className="mb-8 grid gap-4 md:grid-cols-2">
            <div className="rounded-2xl bg-white p-6 shadow-md">
              <h3 className="mb-4 flex items-center gap-2 text-lg font-bold text-gray-800">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-100">
                  <AiFillPhone className="text-[#457B9D]" />
                </div>
                Call or Text
              </h3>
              <div className="flex items-center gap-3">
                <a
                  href="tel:+18707792229"
                  className="text-xl font-bold text-[#457B9D] transition-colors hover:text-[#365f7a]"
                >
                  870-779-2229
                </a>
                <a
                  href="sms:+18707792229"
                  className="rounded-full bg-blue-100 p-2 text-[#457B9D] transition-all hover:bg-[#457B9D] hover:text-white"
                >
                  <MdSms className="text-lg" />
                </a>
                <a
                  href="tel:+18707792229"
                  className="rounded-full bg-blue-100 p-2 text-[#457B9D] transition-all hover:bg-[#457B9D] hover:text-white"
                >
                  <AiFillPhone className="text-lg" />
                </a>
              </div>
            </div>

            <div className="rounded-2xl bg-white p-6 shadow-md">
              <h3 className="mb-4 flex items-center gap-2 text-lg font-bold text-gray-800">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-100">
                  <MdSchedule className="text-[#457B9D]" />
                </div>
                Hours
              </h3>
              <div className="space-y-3 text-sm text-gray-700">
                <p className="font-medium">Call or text for an appointment.</p>
                <div>
                  <p className="font-medium">Parenting and baby care classes</p>
                  <div className="mt-1 space-y-1">
                    <div className="flex justify-between">
                      <span>Tuesday</span>
                      <span>6:30 PM</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Wednesday</span>
                      <span>1:00 PM</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="overflow-hidden rounded-2xl shadow-lg">
            <iframe
              defer
              src="https://www.google.com/maps?q=4415+Jefferson+Ave%2C+Texarkana%2C+AR+71854&output=embed"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="h-96 w-full"
              title="pathway_map"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}
